import {
  Button,
  makeStyles,
  Slider,
  TextField,
  Toolbar,
} from "@material-ui/core";
import AppBar from "@material-ui/core/AppBar";
import Dialog from "@material-ui/core/Dialog";
import MenuItem from "@material-ui/core/MenuItem";
import { withStyles } from "@material-ui/core/styles";
import clsx from "clsx";
import { useFormik } from "formik";
import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import * as Yup from "yup";
import { setPayloadForFetchSoundLists } from "..";
import { toAbsoluteUrl } from "../../../../../../../Utils/_helpers";
import { Loader2 } from "../../../../../../util/loading";
import { useMobileViewport } from "../../../../../../util/mobileViewPort";
import { actions } from "../../../../../Dashboard/_redux/dashboardRedux";
import {
  fetchTextToSpeech,
  fetchTTSSoundsLists,
  postUploadedUserSound,
  setCurrentPage,
  setSoundListingApiPayload,
  uploadTTS,
} from "../../../../state/slices/soundsSlice";
import ConfigurationToastMessage from "../../Util/ConfigurationToastMessage";
import SoundsDialog from "../Utils/Popup/SoundsDialog";
import ReviewSound from "./ReviewSound";
import WhatIsTag from "./WhatIsTag";

const useStyles = makeStyles((theme) => ({
  appBar: {
    position: "relative",
    backgroundColor: "white",
    boxShadow: "none",
  },

  paper: {
    width: "510px",
    maxWidth: "none",
    display: "flex",
    maxHeight: "100%",
    height: "100%",
    margin: 0,
    boxShadow: "0 2px 18px 0 rgba(0, 0, 0, 0.13)",
    border: "solid 1px rgba(210, 201, 197, 0.3)",
    backgroundColor: "white",
    padding: "25px",
    [theme.breakpoints.down("md")]: {
      width: "100%",
      padding: "17px",
    },
  },
  scrollPaper: {
    alignItems: "baseline",
    width: "100%",
    maxWidth: "none",
    justifyContent: "end",
    [theme.breakpoints.down("md")]: {
      alignItems: "center",
    },
  },
  container: {
    display: "flex",
    flexWrap: "wrap",
  },
  formControl: {
    marginRight: theme.spacing(4),
    marginLeft: theme.spacing(2),
    display: "flex",
    minWidth: 120,
  },

  root: {
    "& .MuiOutlinedInput-input": {
      borderRadius: "4px",
      backgroundColor: "#f3f6f9",
    },

    "& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline": {
      borderColor: "#ccd6e3",
    },

    "&:hover .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline": {
      borderColor: "purple",
    },
    "& .MuiInputLabel-root.Mui-focused": {
      color: "purple",
    },
    "& .MuiFormLabel-root.Mui-focused": {
      color: "purple",
    },
    "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
      borderColor: "purple",
    },
    "& .MuiOutlinedInput-multiline": {
      backgroundColor: "#f3f6f9",
    },
  },

  highLightText: {
    color: "#892193",
    fontSize: "12px",
    cursor: "pointer",
    "&:hover": {
      color: "#892193",
    },
  },

  secondaryLabel: {
    color: "#9d9db1",
    fontSize: "12px",
    fontWeight: 500,
  },
}));

const CustomSlider = withStyles({
  root: {
    color: "#2c3687",
    height: 7,
  },
  thumb: {
    height: 20,
    color: "#fff",
    width: 20,
    backgroundColor: "#2c3687",
    border: "2px solid #fff",
    marginTop: -6,
    marginLeft: -12,
    "&:focus, &:hover, &$active": {
      boxShadow: "inherit",
    },
  },
  active: {},
  valueLabel: {
    left: "calc(-50% + 4px)",
    top: "33px",
    "& > span": {
      borderRadius: "99px",
    },
    "& > span > span": {
      color: "#2c3687",
      fontSize: "14px",
      fontWeight: 600,
    },
  },

  track: {
    height: 8,
    borderRadius: 4,
  },
  rail: {
    height: 8,
    borderRadius: 4,
  },
})(Slider);

const CreateTTS = ({
  openCreateTTSDialog,
  handleCloseCreateTTS,
  getSoundList,
}) => {
  const languageOptions = [
    {
      label: "Hindi (in-IN)",
      value: "Hindi",
    },
    {
      label: "English(Indian)(en-IN)",
      value: "English-IN",
    },
  ];

  const voiceOptionsList = [
    {
      label: "Aditi",
      value: "Aditi",
    },
    {
      label: "Raveena",
      value: "Raveena",
    },
  ];

  const classes = useStyles();

  const dispatch = useDispatch();

  const [openTagsPopup, setOpenTagsPopup] = useState(false);
  const [isSoundConverted, setIsSoundConverted] = useState(false);
  const [convertedSoundURL, setConvertedSoundURL] = useState("");
  const [voiceOptions, setVoiceOptions] = useState([]);
  const [convertedTextToSound, setConvertedTextToSound] = useState({});

  const [toastInfo, setToastInfo] = useState({
    open: false,
    severity: "info",
    snackbarMessage: "",
  });

  const {
    activeSoundTab,
    pageSize,
    soundListMetaData,
    searchQuery,
    currentPage,
  } = useSelector((state) => state.soundsSlice);

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      soundName: "",
      lang: "",
      voice: "",
      text: `<emphasis level="moderate">Text to Speech Service use</emphasis> करने के लिए धन्यवाद। आपका Account नंबर <say-as interpret-as="telephone">123456789</say-as> है`,
      rate: 100,
      vol: 0,
    },
    validationSchema: Yup.object().shape(
      {
        soundName: Yup.string()
          .required("Please enter Sound name.")
          .min(1)
          .matches(
            /^[a-z0-9]+$/i,
            "The sound name should not contain any special characters."
          )
          .max(
            30,
            "Sound Name can hold up to 30 Characters. Please remove some characters."
          ),
        lang: Yup.string()
          .required("Please select Language.")
          .min(1),
        voice: Yup.string()
          .required("Please select Voice.")
          .min(1),
        vol: Yup.string().notRequired(""),
        rate: Yup.string().notRequired(""),
        text: Yup.string()
          .nullable()
          .required("Please enter Description.")
          .when("text", {
            is: (value) => value?.length,
            then: (rule) =>
              rule.max(
                500,
                "Description can accept up to 500 Characters. Please remove some characters."
              ),
          }),
      },
      [["text", "text"]]
    ),
    onSubmit: (values, { resetForm }) => {
      const { soundName, ...rest } = values;
      setIsSoundConverted(false);
      setConvertedTextToSound(rest);
      convertTextToSound(rest);
    },
  });

  const isChangesMadeAfterTextConversion = () => {
    const { soundName, ...rest } = formik.values;
    if (JSON.stringify(rest) !== JSON.stringify(convertedTextToSound))
      return true;
    return false;
  };

  const closeTTSCreation = () => {
    formik.resetForm();
    handleCloseCreateTTS();
    setIsSoundConverted(false);
  };

  const convertTextToSound = (payload) => {
    setConvertedSoundURL("");
    dispatch(
      actions.setLoadingState({
        resource: "create_tts",
        loading_state: "loading",
      })
    );
    dispatch(fetchTextToSpeech(payload)).then((res) => {
      if (!res.error) {
        setIsSoundConverted(true);
        const url = window.URL.createObjectURL(new Blob([res.payload.data]));
        setConvertedSoundURL(url);
      } else {
        setIsSoundConverted(false);
      }
    });
  };

  const closeTagsPopup = () => {
    setOpenTagsPopup(false);
  };

  const handleCloseSnackbar = () => {
    setToastInfo((prevState) => ({
      ...prevState,
      open: false,
    }));
  };

  const setToastValue = (open, msg, status) => {
    setToastInfo((prevState) => ({
      ...prevState,
      open: open,
      snackbarMessage: msg,
      severity: status,
    }));
  };

  const saveSound = () => {
    dispatch(
      actions.setLoadingState({
        resource: "create_tts",
        loading_state: "loading",
      })
    );
    const fieldValues = formik.values;
    const formData = new FormData();
    formData.append("soundname", fieldValues.soundName);
    formData.append("language", fieldValues.lang);
    formData.append("voice", fieldValues.voice);
    formData.append("text_to_be_converted", fieldValues.text);
    formData.append("speech_rate", fieldValues.rate);
    formData.append("sound_volume", fieldValues.vol);
    formData.append("status", 0);
    formData.append("is_converted", 0);
    dispatch(uploadTTS(formData)).then((response) => {
      if (response.error) {
        const { payload } = response;
        setToastValue(true, payload.error, "error");
      } else {
        const {
          payload: {
            data: { msg, id },
          },
        } = response;

        dispatch(
          postUploadedUserSound({
            soundlibobj_id: id,
            type: "TTS",
          })
        );

        closeTTSCreation();
        setToastValue(true, msg[0], "success");
        // getSoundList(1, 10 , true, 1);

        let payload = setPayloadForFetchSoundLists(1, pageSize, activeSoundTab);
        const totalCount = soundListMetaData?.total_count || 0;

        payload = {
          ...payload,
          total_entries: totalCount,
          total_pages: Math.ceil(totalCount / pageSize),
          ...(searchQuery && {
            soundlibobj__soundname__icontains: searchQuery,
          }),
        };
        if (currentPage > 1) {
          dispatch(setSoundListingApiPayload(payload));
          dispatch(setCurrentPage(1));
        } else {
          dispatch(fetchTTSSoundsLists(payload));
        }
      }
    });
  };

  return (
    <div>
      <ConfigurationToastMessage
        severity={toastInfo.severity}
        snackbarMessage={toastInfo.snackbarMessage}
        open={toastInfo.open}
        handleCloseSnackbar={handleCloseSnackbar}
      />
      <Dialog
        disableBackdropClick
        classes={{
          paper: classes.paper,
          scrollPaper: classes.scrollPaper,
        }}
        style={{ zIndex: "9801" }}
        open={openCreateTTSDialog}
        onClose={closeTTSCreation}
      >
        <div className="row">
          <Loader2 resource="create_tts" />
          <div className="col-lg-12">
            <AppBar className={classes.appBar}>
              <Toolbar
                className={`d-flex justify-content-between px-3 ${clsx({
                  "align-items-start": useMobileViewport(),
                })}`}
              >
                <div className="secondary-header d-flex align-items-center">
                  <img
                    className=""
                    src={`${toAbsoluteUrl("/media/sr/icons/tts.svg")}`}
                    alt="clock"
                    style={{
                      width: "32px",
                      height: "32px",
                      marginRight: "14px",
                    }}
                  />
                  <div className={`d-flex flex-column`}>
                    <span className="mb-1 pt-3">TTS Sound</span>
                    <span style={{ fontSize: "12px", color: "#6c7293" }}>
                      Convert Written Text to Natural-Sounding Audio
                    </span>
                  </div>
                </div>
                <img
                  alt="close"
                  src={toAbsoluteUrl("/media/sr/icons/close.svg")}
                  className={`next-arrow-icon ${clsx({
                    "mt-3": useMobileViewport(),
                  })}`}
                  onClick={closeTTSCreation}
                  style={{ cursor: "pointer", width: "20px", height: "20px" }}
                />
              </Toolbar>
            </AppBar>

            <form className="form" onSubmit={formik.handleSubmit}>
              <div className="w-100  pr-10">
                <div>
                  <div className="mt-2 ml-5">
                    <TextField
                      id="soundName"
                      name="soundName"
                      className={classes.root}
                      autoComplete="off"
                      autoFocus={false}
                      variant="outlined"
                      label="Enter Sound Name"
                      margin="dense"
                      fullWidth
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.soundName}
                    />

                    {formik.touched.soundName && formik.errors.soundName && (
                      <div className="fv-plugins-message-container">
                        <div className="fv-help-block">
                          {formik.errors.soundName}
                        </div>
                      </div>
                    )}
                  </div>

                  <div className="mt-2 ml-5">
                    <TextField
                      select
                      className={classes.root}
                      id="lang"
                      name="lang"
                      variant="outlined"
                      label="Select Language"
                      margin="dense"
                      fullWidth
                      value={formik.values.lang}
                      SelectProps={{
                        MenuProps: {
                          style: {
                            zIndex: 9999,
                          },
                          PaperProps: {},
                        },
                      }}
                      onChange={(event) => {
                        if (event.target.value.includes("English-IN"))
                          setVoiceOptions(voiceOptionsList);
                        else {
                          setVoiceOptions([voiceOptionsList[0]]);
                        }
                        formik.setFieldValue("lang", event.target.value);
                        formik.setFieldValue("voice", "");
                        formik.handleChange(event)
                      }}
                    >
                      {languageOptions.map((option) => {
                        return (
                          <MenuItem key={option.value} value={option.value}>
                            {option.label}
                          </MenuItem>
                        );
                      })}
                    </TextField>
                    {formik.touched.lang && formik.errors.lang && (
                      <div className="fv-plugins-message-container">
                        <div className="fv-help-block">
                          {formik.errors.lang}
                        </div>
                      </div>
                    )}
                  </div>

                  <div className="mt-2 ml-5">
                    <TextField
                      select
                      id="voice"
                      name="voice"
                      className={classes.root}
                      variant="outlined"
                      label="Select Voice"
                      margin="dense"
                      fullWidth
                      value={formik.values.voice}
                      SelectProps={{
                        MenuProps: {
                          style: {
                            zIndex: 9999,
                          },
                          PaperProps: {},
                        },
                      }}
                      onChange={formik.handleChange}
                    >
                      {formik.values.lang &&
                        voiceOptions.map((option) => {
                          return (
                            <MenuItem key={option.value} value={option.value}>
                              {option.label}
                            </MenuItem>
                          );
                        })}
                    </TextField>
                    {formik.touched.voice && formik.errors.voice && (
                      <div className="fv-plugins-message-container">
                        <div className="fv-help-block">
                          {formik.errors.voice}
                        </div>
                      </div>
                    )}
                  </div>

                  <div className="mt-2 ml-5">
                    <TextField
                      id="text"
                      name="text"
                      multiline
                      className={classes.root}
                      rows={10}
                      autoComplete="off"
                      variant="outlined"
                      label="Enter Description"
                      margin="dense"
                      value={formik.values.text}
                      fullWidth
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                    />
                    {formik.touched.text && formik.errors.text && (
                      <div className="fv-plugins-message-container">
                        <div className="fv-help-block">
                          {formik.errors.text}
                        </div>
                      </div>
                    )}
                    <div className="d-flex justify-content-between pt-2">
                      <div>
                        <span>
                          <strong>
                            Characters Left:{" "}
                            {formik.values.text.length > 500
                              ? 0
                              : 500 - formik.values.text.length}
                          </strong>
                        </span>
                      </div>

                      <div
                        onClick={() => {
                          setOpenTagsPopup(true);
                        }}
                        className={`${classes.highLightText} cursor-pointer`}
                      >
                        <span>Know more about Tags</span>
                      </div>
                    </div>
                  </div>

                  <div className="mt-7 ml-5">
                    <div className="mb-3">
                      <span className={classes.secondaryLabel}>
                        Rate of Speech
                      </span>
                    </div>
                    <div className="d-flex align-items-center">
                      <span className={`mr-4 ${classes.secondaryLabel}`}>
                        20
                      </span>
                      <CustomSlider
                        id="rate"
                        name="rate"
                        valueLabelDisplay="on"
                        defaultValue={100}
                        min={20}
                        max={200}
                        onChange={(e, val) => formik.setFieldValue("rate", val)}
                        value={formik.values.rate ?? 100}
                        onBlur={formik.handleBlur}
                      />
                      <span className={`ml-4 ${classes.secondaryLabel}`}>
                        200
                      </span>
                    </div>
                  </div>

                  <div className="mt-10 mb-15 ml-5">
                    <div className="mb-3">
                      <span className={classes.secondaryLabel}>Volume</span>
                    </div>
                    <div className="d-flex align-items-center">
                      <span className={`mr-4 ${classes.secondaryLabel}`}>
                        -6
                      </span>
                      <CustomSlider
                        id="vol"
                        name="vol"
                        valueLabelDisplay="on"
                        onChange={(e, val) => formik.setFieldValue("vol", val)}
                        value={formik.values.vol ?? 0}
                        defaultValue={0}
                        min={-6}
                        max={6}
                        onBlur={formik.handleBlur}
                      />
                      <span className={`ml-4 ${classes.secondaryLabel}`}>
                        6
                      </span>
                    </div>
                  </div>
                </div>

                {isSoundConverted && (
                  <div>
                    <ReviewSound soundUrl={convertedSoundURL} />
                    {isChangesMadeAfterTextConversion() && (
                      <span style={{ fontSize: "11px" }}>
                        TTS Settings have changed, please convert again to load
                        the new changes
                      </span>
                    )}
                  </div>
                )}

                <div
                  className={`ml-5 mt-5 d-flex flex-column flex-grow-1 align-items-center text-transform-none
                 `}
                >
                  {isSoundConverted && !isChangesMadeAfterTextConversion() ? (
                    <Button
                      onClick={() => {
                        saveSound();
                      }}
                      className="sr-btn mr-2 ml-2 w-100 contained-btn"
                      style={{ textTransform: "none" }}
                    >
                      Save Sound
                    </Button>
                  ) : (
                    <Button
                      type="submit"
                      className="sr-btn mr-2 ml-2 w-100 contained-btn"
                      style={{ textTransform: "none" }}
                    >
                      Convert to Sound
                    </Button>
                  )}
                  <span
                    onClick={() => {
                      closeTTSCreation();
                    }}
                    className={`mt-8 ${classes.highLightText} ${classes.label}`}
                  >
                    Cancel
                  </span>
                </div>
              </div>
            </form>
          </div>
        </div>
      </Dialog>
      {openTagsPopup && (
        <SoundsDialog
          open={openTagsPopup}
          handleClose={() => {
            closeTagsPopup(false);
          }}
          maxWidth="lg"
          width="100%"
          title="Using the TAGS"
        >
          <WhatIsTag />
        </SoundsDialog>
      )}
    </div>
  );
};

export default CreateTTS;
